document.addEventListener("DOMContentLoaded", function () {
  const phoneInput = document.getElementById("ContactForm-phone");

  if (phoneInput) {
    phoneInput.addEventListener("input", function (e) {
      const allowedPattern = /[^0-9\s\-\(\)\+]/g;
      const currentValue = e.target.value;
      const filteredValue = currentValue.replace(allowedPattern, "");

      if (currentValue !== filteredValue) {
        e.target.value = filteredValue;
      }
    });

    phoneInput.addEventListener("paste", function (e) {
      setTimeout(() => {
        const allowedPattern = /[^0-9\s\-\(\)\+]/g;
        const currentValue = e.target.value;
        const filteredValue = currentValue.replace(allowedPattern, "");
        e.target.value = filteredValue;
      }, 0);
    });
  }
});